(function (angular, app) {
    "use strict";

    angular.module(app.modules.member.name)
       .service(app.modules.member.services.detail, MemberService);

    MemberService.$inject = ["$q", "$templateCache", "$http"
       , app.modules.common.services.http
       , app.modules.common.services.storage
       , app.modules.common.services.eventbus
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
       , app.modules.common.decorators.resource
       , app.modules.group.services.groups
       , app.modules.outing.services.outings
       , app.modules.member.services.search
       , app.modules.course.services.search
       , app.modules.invitation.services.invite
       , app.modules.handicap.services.handicaps
       , app.modules.scoring.services.score
    ];

    function MemberService($q, $templateCache, $ahttp, $http 
        , ggStorage
        , ggEvents
        , ggSettings
        , ggFunctions
        , ggResource
        , ggGroupSvc
        , ggOutingSvc
        , ggMemberSearchSvc
        , ggCourseSearchSvc
        , ggInvitations
        , ggHandicap
        , ggScoringSvc
        ) {

        var _Member = function () {

            // User to manage session
            this.Auth = {
                isAuthenticated: false
                 , timeCheck: 0
                 , userName: ""
                 , password: ""
                 , roles: []
                 , authToken : null

            }
            // Set by API
            this.Detail = {};

            this.Handicap = {};

            // Use
            this.isCurrent = true;

            this.pageTemplates = {
               fetch: function (templateId) {
                  var template = $templateCache.get(templateId);
                  if (!template) {
                     var url = appFunctions.cacheBuster(templateId);
                     return $ahttp.get(url).then(function (data) {
                        $templateCache.put(templateId, data.data);
                        return data.data;
                     });
                  } else {
                     return $q.resolve(template);
                  }
               }
            }

            this.Session = {
               appSetup: null
                , bookmark: {
                   home: {
                      tab: null
                      , tab2: null
                      , results: []
                      , scrollLimit: null
                      , scrollPosition: null
                   }
                   , handicaplookup: {
                      tab: null
                       , tab2: null
                       , results: []
                       , scrollLimit: null
                       , scrollPosition: null
                   }
                   , memberdetail: {
                      tab: null
                       , tab2: null
                      , results: []
                       , scrollLimit: null
                       , scrollPosition: null
                   }
                   , groups: {
                       tab: null
                      , tab2: null
                      , results: []
                      , scrollLimit: null
                      , scrollPosition: null
                   }
                   , outing: {
                       tab: null
                      , tab2: null
                      , results: []
                      , scrollLimit: null
                      , scrollPosition: null
                   }
                   , scoring: {
                       tab: null
                      , tab2: null
                      , results: []
                      , scrollLimit: null
                      , scrollPosition: null
                   }
                   , course: {
                       tab: null
                      , tab2: null
                      , scrollLimit: null
                      , scrollPosition: null
                   }
                }
                , pageTemplates: {
                   fetch: function (templateId) {
                      var template = $templateCache.get(templateId);
                      if (!template) {
                         var url = ggFunctions.cacheBuster(templateId);
                         return $ahttp.get(url).then(function (data) {
                            $templateCache.put(templateId, data.data);
                            return data.data;
                         });
                      } else {
                         return $q.resolve(template);
                      }
                   }
                }
                , connectivity: {
                    currentTime: null
                    , isConnected : function(){
                        var rv = false;

                        var getCurrentTime = function () {
                            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.networkTime;
                            return $http.get(apipath, {ignoreLoadingBar:true}).then(function (data) {
                                _member.Session.connectivity.currentTime = data.data.value;
                                return;
                            }, function (fail) {
                                _member.Session.connectivity.currentTime = null;
                                return;
                            });
                        }

                        return getCurrentTime().then(function(){
                            rv = _member.Session.connectivity.currentTime ? true : false;
                            return rv;
                        });
                    }
                }
            }

            // Meber Methods
            var _member = this;
            this.Authenticate = {
                Login: function (resp) {

                    // Build Request
                    var apipath = ggSettings.gnapi.root + ggSettings.gnapi.login.token;

                    var form = {};
                    form.grant_type = "password";
                    form.username = _member.Auth.userName;
                    form.password = _member.Auth.password;

                    // Save Username to Storage
                    ggStorage.set(ggStorage.keys.member.username, form.username);
                    ggStorage.set(ggStorage.keys.member.password, form.password);


                    if (app.Branding && !isNaN(form.username)) {
                        form.username = app.Branding.loginPrefix + form.username;
                    }

                    // Post and transform the data
                    return $http.post(apipath, form, true).then(function (data) {
                        if (data && data.status == "200") {
                            var result = data.data

                            // Store token for later use
                            ggStorage.set(ggStorage.keys.member.bearertoken, result.access_token);
                            ggStorage.set(ggStorage.keys.member.refreshtoken, result.refresh_token);
                            ggStorage.set(ggStorage.keys.member.id, result.individualId);
                            ggStorage.set(ggStorage.keys.member.firstname, result.firstName);
                            ggStorage.set(ggStorage.keys.member.lastname, result.lastName);

                            // Seet detail name for display
                            _member.Detail.firstName = result.firstName;
                            _member.Detail.lastName = result.lastName;
                            _member.Auth.timeCheck = 0;
                            _member.Auth.isAuthenticated = false;
                            _member.Auth.roles = [];

                            return data;

                        }
                    }, function (data) {
                        if (data.data && data.data.error_description) {
                            data.statusText = data.data.error_description
                        }
                        return data;
                    });

                }
               , Logout: function (resp) {

                   // Remove Token
                   ggStorage.set(ggStorage.keys.member.bearertoken, null);
                   ggStorage.set(ggStorage.keys.member.refreshtoken, null);
                   ggStorage.set(ggStorage.keys.member.id, null);

                   // Reset Member Object
                   return _member.Authenticate.Reset();

                   // Refresh App-- Controller 
                   // DO this in the controller
                   // top.location.href = app.settings.rootURL;

                   if (resp) {
                       resp();
                   }
               }
               , Reset: function () {
                   ggStorage.set(ggStorage.keys.member.bearertoken, null);
                   ggStorage.set(ggStorage.keys.member.refreshtoken, null);
                   ggStorage.set(ggStorage.keys.member.id, null);

                   // Save Last ID
                   if (_member.Detail && _member.Detail.id) {
                       ggStorage.set(ggStorage.keys.app.lastMemberId, _member.Detail.id);
                   }

                   _member.Auth.isAuthenticated = false;
                   _member.Auth.timeCheck = 0;

                   _member.Auth.roles = [];
                   // Add Authenticated Role
                   var Role = new _Role;
                   Role.RoleId = -1;
                   Role.Name = "ANONYMOUS";
                   Role.Domain = "";
                   _member.Auth.roles.push(Role);

                   _member.Detail = {};
                   _member.Handicap = {};

                   // Broadcast
                   _member.Authenticate.Broadcast();

                   return $q.when();

               }
               , Broadcast: function () {
                   // Broadcast
                   ggEvents.broadcast(app.modules.common.events.authChange);
               }
               , ValidateToken: function (ovr) {
                   var rv = $q.when();
                   // Only validate every 20 minutes

                   var now = new Date();
                   var lastAuth = now - _member.Auth.timeCheck;
                   // Check every 20 minutes
                   if (!ovr) {
                       if ((_member.Auth.isAuthenticated && lastAuth < 1200000) || (!_member.Auth.isAuthenticated && lastAuth < 5000)) {
                           return rv;
                       }
                   }

                   _member.Auth.timeCheck = new Date();

                   // Get Cookie from machine
                   var bearertoken = ggStorage.get(ggStorage.keys.member.bearertoken);
                   var memberId = ggStorage.get(ggStorage.keys.member.id);

                   // Build Request to Validate Token
                   if (bearertoken && memberId) {

                       var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + memberId + ")/getMemberInfo";
                       return $http.get(apipath, {ignoreLoadingBar : true}).then(function (data) {
                           if (data && data.status == "200") {
                               if (data.data) {
                                   var result = data.data;
                                   if (result.id) {

                                       // Validate the stored Id with the Authentication Request
                                       if (result.id == memberId) {

                                           // Authenticated
                                           _member.Auth.isAuthenticated = true;
                                           _member.Auth.userName = result.userName;

                                           // Reset Roles
                                           _member.Auth.roles = [];

                                           // Add Authenticated Role
                                           var Role = new _Role;
                                           Role.RoleId = 0;
                                           Role.Name = "AUTHENTICATED";
                                           Role.Domain = "";
                                           _member.Auth.roles.push(Role);

                                           // Function fixes for memberDetail
                                           if (result.preferenceSettings && result.preferenceSettings.defaultTeeBoxScorecardId) {
                                               result.preferenceSettings.defaultTeeId = result.preferenceSettings.defaultTeeBoxScorecardId;
                                               delete result.preferenceSettings.defaultTeeBoxScorecardId;
                                           }

                                           if (result.address && result.address.length > 0) {
                                               var address = angular.copy(result.address[0]);
                                               delete result.address;
                                               result.address = address;

                                           }


                                           // Member Data
                                           _member.Detail = result;

                                           // Broadcast
                                           _member.Authenticate.Broadcast();

                                           //return _member.Authenticate.RefreshToken();
                                           
                                           return _member.Network.FetchAppSetup().then(function () {
                                              return _member.Network.FetchAccountData();
                                           });
                                           


                                       } else {
                                           return _member.Authenticate.Reset();
                                       }
                                   } else {
                                       return _member.Authenticate.Reset();
                                   }
                               }
                           } else {
                               return _member.Authenticate.Reset();
                           }
                       }, function (error) {
                           return _member.Authenticate.Reset();
                       });
                   } else {
                       return _member.Authenticate.Reset();
                   }
               }
               , RefreshToken: function () {

                   var apipath = ggSettings.gnapi.root + ggSettings.gnapi.login.token;

                   var form = {};
                   form.grant_type = "refresh_token";
                   form.refresh_token = ggStorage.get(ggStorage.keys.member.refreshtoken);

                   // Post and transform the data
                   return $http.post(apipath, form, true).then(function (data) {
                       if (data && data.status == "200") {
                           var result = data.data
                           ggStorage.set(ggStorage.keys.member.bearertoken, result.access_token);
                           ggStorage.set(ggStorage.keys.member.refreshtoken, result.refresh_token);
                       }
                       return app.Member.Network.FetchAccountData();
                   }, function (e) {
                       // Failed to refresh token.  Dangit.
                       return e;
                   });
               }
            }
            this.Network = {
                RegisterAccount: function (data) {
                    var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail;
                    var form = {};
                    if (data) {
                        form = data;
                    } else {
                        form.email = _member.Detail.email;
                        form.password = _member.Detail.password;
                        form.userName = _member.Detail.userName;
                        form.gender = _member.Detail.gender;
                        form.firstName = _member.Detail.firstName;
                        form.lastName = _member.Detail.lastName;
                        form.address = {
                            postalCode: _member.Detail.address.postalCode
                           , line1: null
                           , line2: null
                           , city: null
                           , region: null
                           , country: null
                        }
                    }

                    // Post the data, but don't transform it.
                    return $http.post(apipath, form, false);
                }
                , SaveAccountDetail: function (data) {

                    var apipath = ggSettings.gnapi.root +ggSettings.gnapi.member.detail + "(" +data.id + ")";
                    var form = {};
                    form.email = data.email;
                    form.username = data.username;
                    
                    if (data.password && data.password != "") {
                        form.password = data.password;
                    } else {
                        form.password = ggStorage.get(ggStorage.keys.member.password);
                    }

                    form.userName = data.userName;
                    form.firstName = data.firstName;
                    form.lastName = data.lastName;
                    form.gender = (data.gender).substring(0,1) == "M" ? "Male" :  "Female";
                    if (data.dateOfBirth) {
                        form.dateOfBirth = data.dateOfBirth;
                    }
                    
                    if (form.mobilePhone && isNaN(form.mobilePhone)) {
                        form.mobilePhone = null;
                    }

                    if (data.address) {
                        form.address = {
                            line1: data.address.line1
                       , line2: data.address.line2
                        , city: data.address.city
                        , region: data.address.region
                        , postalCode: data.address.postalCode
                        , country: data.address.country || "US"
                        }
                    } else {
                        form.address = _member.Detail.address;
                    }
                    
                    if (data.preferenceSettings) {
                        form.preferenceSettings = {
                            trackStats: data.preferenceSettings.trackStats 
                            , postHoleByHole: data.preferenceSettings.postHoleByHole 
                            , trackStrokesGained: data.preferenceSettings.trackStrokesGained 

                            , trackPenalties: data.preferenceSettings.trackPenalties
                            , trackClub: data.preferenceSettings.trackClub 
                            , trackDriveDistance: data.preferenceSettings.trackDriveDistance 

                            , trackFairways: data.preferenceSettings.trackFairways 
                            , trackUpDown: data.preferenceSettings.trackUpDown 
                            , trackSandies: data.preferenceSettings.trackSandies 
                            , trackPuttLength: data.preferenceSettings.trackPuttLength 
                            , defaultCourseId: data.preferenceSettings.defaultCourseId
                            , defaultTeeId: data.preferenceSettings.defaultTeeId

                        }
                    } else {
                        form.preferenceSettings = _member.Detail.preferenceSettings;
                    }

                    if (form.clubMembership) {
                        delete form.clubMembership;
                    }

                    form.commSettings = _member.Detail.commSettings;
                    return $http.put(apipath, form);
                }
                , ResetPassword: function (data) {
                    var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.passwordreset;
                    var form = {};
                    form.username = data.username;
                    return $http.post(apipath, form, false);
                }
                , FetchAuthToken: function () {
                   var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.createAuthToken;
                   apipath = apipath.replace("(id)", "(" + app.Member.Detail.id + ")");
                   var form = {ignoreLoadingBar : true};
                   return $http.post(apipath, form).then(function (data) {
                      if (data) {
                         _member.Auth.authToken = data.data.value;
                      }
                      return;
                   }, function (fail) {
                      return fail;
                   });
                }
                , FetchAppSetup: function () {
                   var apipath = ggSettings.aspapi.root + ggSettings.aspapi.app.fetchAppSetup;
                   return $http.classic(apipath, {ignoreLoadingBar : true}).then(function (data) {
                      _member.Session.appSetup = data.data;
                      return;
                   }, function (fail) {
                      return;
                   });
                }
                , FetchCompliantClub: function () {
                    var apipath = ggSettings.aspapi.root + ggSettings.aspapi.app.fetchCompliantClub;
                   return $http.classic(apipath, {})
                }
                , FetchStripeCustomerDetail: function () {
                   var apipath = ggSettings.aspapi.root + ggSettings.aspapi.stripe.fetchStripeCustomerDetail;
                  return $http.classic(apipath, {});
                }
                , InsertStripeBasket: function (form) {
                    var apipath = ggSettings.aspapi.root + ggSettings.aspapi.stripe.insertStripeBasket;
                  return $http.classic(apipath, form);
               }
                , InsertStripeSubscription: function (form) {
                   var apipath = ggSettings.aspapi.root + ggSettings.aspapi.stripe.insertStripeSubscription;
                  return $http.classic(apipath, form);
               }
                , UpdatePrepaidCode: function (form) {
                  var apipath = ggSettings.aspapi.root + ggSettings.aspapi.stripe.updatePrepaidCode;
                  return $http.classic(apipath, form);
                }
                , UpdateIOSPayment: function (form) {
                    var apipath = ggSettings.aspapi.root + ggSettings.aspapi.ios.updateIOSPayment;
                    return $http.classic(apipath, form);
                }
                , FetchAccountData: function () {

                    // Make sure we are using the latest and greatest local data.
                    var cacheVersion = ggStorage.get(ggStorage.keys.app.version);
                    var cacheId = ggStorage.get(ggStorage.keys.app.lastMemberId);

                    var chain = $q.when();


                    if (_member.Auth.isAuthenticated && cacheVersion != ggSettings.version || cacheId != _member.Detail.id) {
                        chain.then(_member.Network.Data.Reset());
                    }

                    ggStorage.set(ggStorage.keys.app.lastMemberId, _member.Detail.id);

                    chain = chain.then(app.Member.Network.Data.Location.locate);

                    // When logging // always get Invitations, Clubs Memberships, Revisions
                    //chain = chain.then(_member.Network.Data.Invitations.fetch);
                    //chain = chain.then(_member.Network.Data.Clubs.fetch);
                    //chain = chain.then(_member.Network.Data.Revision.fetch);

                    return chain;
                }
                , Data: {
                    Reset: function () {

                        // Reset Storage
                        ggStorage.set(ggStorage.keys.app.version, ggSettings.version);

                        // Prefs
                        ggStorage.set(ggStorage.keys.member.prefs.course.teeId, null);
                        ggStorage.set(ggStorage.keys.member.prefs.course.courseObj, null);
                        ggStorage.set(ggStorage.keys.member.prefs.course.courseId, null);

                        ggStorage.set(ggStorage.keys.member.prefs.group.groupObj, null);
                        ggStorage.set(ggStorage.keys.member.prefs.group.groupId, null);

                        // Data
                        ggStorage.set(ggStorage.keys.members.my.isCurrent, false);
                        ggStorage.set(ggStorage.keys.members.my.data, null);
                        ggStorage.set(ggStorage.keys.members.partners.isCurrent, false);
                        ggStorage.set(ggStorage.keys.members.partners.data, null);

                        ggStorage.set(ggStorage.keys.courses.my.isCurrent, false);
                        ggStorage.set(ggStorage.keys.courses.my.data, null);
                        ggStorage.set(ggStorage.keys.courses.location.isCurrent, false);
                        ggStorage.set(ggStorage.keys.courses.location.data, null);

                        ggStorage.set(ggStorage.keys.groups.my.isCurrent, false);
                        ggStorage.set(ggStorage.keys.groups.my.data, null);
                        ggStorage.set(ggStorage.keys.groups.organizer.isCurrent, false);
                        ggStorage.set(ggStorage.keys.groups.organizer.data, null);

                        ggStorage.set(ggStorage.keys.clubs.my.isCurrent, false);
                        ggStorage.set(ggStorage.keys.clubs.my.data, null);
                        ggStorage.set(ggStorage.keys.clubs.primary, null);



                        ggStorage.set(ggStorage.keys.invitations.my.isCurrent, false);
                        ggStorage.set(ggStorage.keys.invitations.my.data, null);

                        ggStorage.set(ggStorage.keys.outings.organizer.isCurrent, false);
                        ggStorage.set(ggStorage.keys.outings.organizer.data, null);
                        ggStorage.set(ggStorage.keys.outings.player.isCurrent, false);
                        ggStorage.set(ggStorage.keys.outings.player.data, null);
                        ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.isCurrent, false);
                        ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.data, null);

                        ggStorage.set(ggStorage.keys.scoring.inProgress.isCurrent, false);
                        ggStorage.set(ggStorage.keys.scoring.inProgress.data, null);
                        ggStorage.set(ggStorage.keys.scoring.recent.isCurrent, false);
                        ggStorage.set(ggStorage.keys.scoring.recent.data, null);
                        ggStorage.set(ggStorage.keys.scoring.archive.isCurrent, false);
                        ggStorage.set(ggStorage.keys.scoring.archive.data, null);
                        ggStorage.set(ggStorage.keys.scoring.revision.isCurrent, false);
                        ggStorage.set(ggStorage.keys.scoring.revision.data, null);


                    }
                   , Location: {
                       isCurrent: false
                      , longitude: null
                      , latitude: null
                      , radius: 50
                      , lastPoll: null
                      , msg: ""
                      , isPostalCode: false
                      , locate: function (cb) {

                          if (_member.Network.Data.Location.isCurrent) {
                              if (cb) {
                                  cb();
                              }
                          } else {
                              var geoSuccess = function (pos) {
                                  _member.Network.Data.Location.latitude = pos.coords.latitude;
                                  _member.Network.Data.Location.longitude = pos.coords.longitude;
                                  _member.Network.Data.Location.isCurrent = true;
                                  _member.Network.Data.Location.lastPoll = Date.now();
                                  if (cb) {
                                      cb();
                                  }
                              }

                              var geoFail = function (error) {
                                  // Fetch GEO with PostalCode
                                  if (_member.Detail.address.postalCode != "") {
                                      var apipath = ggSettings.grpapi.root + ggSettings.grpapi.location.postalCode + "(postalCode='" + _member.Detail.address.postalCode + "')";
                                      return $http.get(apipath, {}).then(function (data) {
                                          if (data && data.status == "200") {
                                              _member.Network.Data.Location.latitude = data.data.latitude;
                                              _member.Network.Data.Location.longitude = data.data.longitude;
                                              _member.Network.Data.Location.isCurrent = true;
                                              _member.Network.Data.Location.isPostalCode = true;
                                              _member.Network.Data.Location.lastPoll = Date.now();;
                                          }
                                          if (cb) {
                                              cb();
                                          }
                                      });

                                  } else {
                                      _member.Network.Data.Location.msg = "Location information is unavailable.";
                                      _member.Network.Data.Location.latitude = null;
                                      _member.Network.Data.Location.longitude = null;
                                      _member.Network.Data.Location.isCurrent = false;
                                      _member.Network.Data.Location.lastPoll = null;
                                      if (cb) {
                                          cb();
                                      }
                                  }
                              }

                              var geoOption = {
                                  enableHighAccuracy: true,
                                  timeout: 5000,
                                  maximumAge: 0
                              };

                              if (navigator.geolocation) {
                                  navigator.geolocation.getCurrentPosition(geoSuccess, geoFail, geoOption);
                              } else {
                                  _member.Network.Data.Location.latitude = null;
                                  _member.Network.Data.Location.longitude = null;
                                  _member.Network.Data.Location.isCurrent = false;
                                  _member.Network.Data.Location.lastPoll = null;
                                  geoFail();
                              }
                          }
                      }
                   }
                   , Friends: {
                       fetch: function (isRefresh) {

                           // Get Current Storage
                           var isCurrent = ggStorage.get(ggStorage.keys.members.my.isCurrent);
                           var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.my.data)) || [];

                           if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                               // Reset storage
                               ggStorage.set(ggStorage.keys.members.my.isCurrent, false);
                               ggStorage.set(ggStorage.keys.members.my.data, null);

                               return ggMemberSearchSvc.search.fetchMemberSearchByFriends({ memberId: _member.Detail.id }).then(function (data) {
                                   if (data && data.status == "200") {
                                       var storeData = data.data.value;
                                       storeData.sort(function (a, b) {
                                           if (a.lastName.trim() < b.lastName.trim()) return -2;
                                           if (a.lastName.trim() > b.lastName.trim()) return 2;
                                           if (a.firstName.trim() < b.firstName.trim()) return -1;
                                           if (a.firstName.trim() < b.firstName.trim()) return -1;
                                           return 0;
                                       });
                                       ggStorage.set(ggStorage.keys.members.my.isCurrent, true);
                                       ggStorage.set(ggStorage.keys.members.my.data, storeData);
                                   }
                                   return storeData;
                               }, function (error) { return error; });
                           } else {
                               return $q.resolve(storeData);
                           }
                       }
                      , follow: function (data) {

                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.my.data)) || [];
                          var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + _member.Detail.id + ")/friends/$ref";
                          var form = {
                              "@odata.id": ggSettings.gnapi.root + "members(" + data.id + ")"
                          }

                          return $http.post(apipath, form, false).then(function (d) {
                              if (d && (d.status == "201" || d.status == "204")) {
                                  storeData.push(data);
                              }
                              // Sort
                              storeData.sort(function (a, b) { return a.lastName - b.lastName });
                              ggStorage.set(ggStorage.keys.members.my.data, storeData)
                              return storeData;
                          });
                      }
                      , unfollow: function (data) {
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.my.data)) || [];
                          var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + _member.Detail.id + ")/friends(" + data.id + ")/$ref";
                          return $http.delete(apipath, {}).then(function (d) {
                              if (d && (d.status == "200" || d.status == "204")) {
                                  for (var l = 0; l < storeData.length; l++) {
                                      var item = storeData[l];
                                      if (item.id == data.id) {
                                          storeData.splice(l, 1);
                                          break;
                                      }
                                  }
                              }
                              ggStorage.set(ggStorage.keys.members.my.data, storeData);
                              return storeData;
                          }, function () {
                              // User probably not in list and returned an error
                              for (var l = 0; l < storeData.length; l++) {
                                  var item = storeData[l];
                                  if (item.id == data.id) {
                                      storeData.splice(l, 1);
                                      break;
                                  }
                              }
                              ggStorage.set(ggStorage.keys.members.my.data, storeData);
                              return storeData;
                          });
                      }
                      , isFollowing: function (id) {
                          var r = false;
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.my.data)) || [];
                          for (var l = 0; l < storeData.length; l++) {
                              var item = storeData[l];
                              if (item.id == id) {
                                  r = true;
                                  break;
                              }
                          }
                          return r;
                      }

                   }
                   , Partners: {
                       fetch: function (isRefresh) {
                           // Get Current Storage
                           var isCurrent = ggStorage.get(ggStorage.keys.members.partners.isCurrent);
                           var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.partners.data)) || [];

                           return $q.resolve(storeData);
                           /*
                           if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                              // Reset storage
                              ggStorage.set(ggStorage.keys.members.my.isCurrent, false);
                              ggStorage.set(ggStorage.keys.members.my.data, null);
     
                              return ggMemberSearchSvc.search.fetchMemberSearchByFriends({ memberId: _member.Detail.id }).then(function (data) {
                                 if (data && data.status == "200") {
                                    var storeData = data.data.value;
                                    storeData.sort(function (a, b) {
                                       if (a.lastName.trim() < b.lastName.trim()) return -2;
                                       if (a.lastName.trim() > b.lastName.trim()) return 2;
                                       if (a.firstName.trim() < b.firstName.trim()) return -1;
                                       if (a.firstName.trim() < b.firstName.trim()) return -1;
                                       return 0;
                                    });
                                    ggStorage.set(ggStorage.keys.members.my.isCurrent, true);
                                    ggStorage.set(ggStorage.keys.members.my.data, storeData);
                                 }
                                 return storeData;
                              }, function (error) { return error; });
                           } else {
                              return $q.resolve(storeData);
                           }
                           */
                       }
                      , follow: function (data) {

                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.partners.data)) || [];
                          storeData.push(data);
                          ggStorage.set(ggStorage.keys.members.partners.data, storeData);

                          return $q.resolve(storeData);
                      }
                      , unfollow: function (data) {
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.partners.data)) || [];

                          if (storeData) {
                              for (var l = 0; l < storeData.length; l++) {
                                  var item = storeData[l];
                                  if (item.id == data.id) {
                                      storeData.splice(l, 1);
                                      break;
                                  }
                              }
                          }
                          ggStorage.set(ggStorage.keys.members.partners.data, storeData);
                          return $q.resolve(storeData);
                      }
                      , isFollowing: function (id) {
                          var r = false;
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.partners.data)) || [];
                          if (storeData) {
                              for (var l = 0; l < storeData.length; l++) {
                                  var item = storeData[l];
                                  if (item.id == id) {
                                      r = true;
                                      break;
                                  }
                              }
                          }
                          return r;
                      }
                   }
                   , Outings: {
                       player: {
                           fetch: function (isRefresh) {

                               // Get Current Storage
                               var isCurrent = ggStorage.get(ggStorage.keys.outings.player.isCurrent);
                               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.outings.player.data)) || [];

                               if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                   // Reset storage
                                   ggStorage.set(ggStorage.keys.outings.player.isCurrent, false);
                                   ggStorage.set(ggStorage.keys.outings.player.data, null);

                                   return ggOutingSvc.search.fetchOutingsByPlayer({ memberId: _member.Detail.id, includeOrganizing: true }).then(function (data) {
                                       if (data && data.status == "200") {
                                           var storeData = data.data.value;

                                           ggStorage.set(ggStorage.keys.outings.player.isCurrent, true);
                                           ggStorage.set(ggStorage.keys.outings.player.data, storeData);
                                       }
                                       return storeData;
                                   }, function (error) { return error; });
                               } else {
                                   return $q.resolve(storeData);
                               }
                           }
                       }
                      , organizer: {
                          fetch: function (isRefresh) {
                              // Get Current Storage
                              var isCurrent = ggStorage.get(ggStorage.keys.outings.organizer.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.outings.organizer.data)) || [];

                              if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                  // Reset storage
                                  ggStorage.set(ggStorage.keys.outings.organizer.isCurrent, false);
                                  ggStorage.set(ggStorage.keys.outings.organizer.data, null);

                                  return ggOutingSvc.search.fetchOutingsByCreator({ createdById: _member.Detail.id }).then(function (data) {
                                      if (data && data.status == "200") {
                                          var storeData = data.data.value;

                                          ggStorage.set(ggStorage.keys.outings.organizer.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.outings.organizer.data, storeData);
                                      }
                                      return storeData;
                                  }, function (error) { return error; });
                              } else {
                                  return $q.when(storeData);
                              }
                          }
                      }
                      , playerOrOrganizer: {
                          fetch: function (isRefresh) {

                              // Get Current Storage
                              var isCurrent = ggStorage.get(ggStorage.keys.outings.playerOrOrganizer.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.outings.playerOrOrganizer.data)) || [];

                              if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                  // Reset storage
                                  ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.isCurrent, false);
                                  ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.data, null);

                                  return ggOutingSvc.search.fetchOutingsByPlayer({ memberId: _member.Detail.id, includeOrganizing: true }).then(function (data) {
                                      if (data && data.status == "200") {
                                          var storeData = data.data.value;

                                          ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.outings.playerOrOrganizer.data, storeData);
                                      }
                                      return storeData;
                                  }, function (error) { return error; });
                              } else {
                                  return $q.resolve(storeData);
                              }
                          }
                      }

                   }
                   , Courses: {
                       
                       fetch: function (isRefresh) {

                           // Get my default course to put on Top.
                           var defaultCourse = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.course.courseObj));
                           var courses = [];
                           if (defaultCourse) {
                               courses.push(defaultCourse);
                           }

                               return ggCourseSearchSvc.search.fetchCourseSearchByMember({ memberId: _member.Detail.id }).then(function (data) {
                                   if (data && data.status == "200") {

                                       for (var c = 0; c < data.data.value.length; c++) {
                                           var course = data.data.value[c];
                                           if (!defaultCourse || course.id != defaultCourse.id) {
                                               courses.push(course);
                                           }
                                       }
                                   }
                                   return courses;
                               }, function (error) { return error; });
                       }
                      , follow: function (data) {

                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.my.data)) || [];
                          var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + _member.Detail.id + ")/courses/$ref";
                          var form = {
                              "@odata.id": ggSettings.gnapi.root + "courses(" + data.id + ")"
                          }
                          return $http.post(apipath, form, false).then(function (d) {
                              if (d && (d.status == "201" || d.status == "204")) {
                                  storeData.push(data);
                                  ggStorage.set(ggStorage.keys.courses.my.data, storeData);
                              }
                              return $q.resolve(storeData);
                          }, function (error) {
                              return $q.resolve(storeData);
                          });
                      }
                      , unfollow: function (id) {
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.my.data)) || [];

                          var apipath = ggSettings.gnapi.root + ggSettings.gnapi.member.detail + "(" + _member.Detail.id + ")/courses(" + id + ")/$ref";
                          return $http.delete(apipath, {}).then(function (d) {
                              if (d && (d.status == "200" || d.status == "204")) {

                                  for (var l = 0; l < storeData.length; l++) {
                                      var item = storeData[l];
                                      if (item.id == id) {
                                          storeData.splice(l, 1);
                                          ggStorage.set(ggStorage.keys.courses.my.data, storeData);
                                          break;
                                      }
                                  }
                              }
                              return $q.resolve(storeData);
                          });
                      }
                      , isFollowing: function (id) {
                          var r = false;
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.my.data)) || [];

                          for (var l = 0; l < storeData.length; l++) {
                              var item = storeData[l];
                              if (item.id == id) {
                                  r = true;
                                  break;
                              }
                          }
                          return r;
                      }
                      , location: {
                          fetch: function (isRefresh, latitude, longitude) {
                              // Get Current Storage
                              var isCurrent = ggStorage.get(ggStorage.keys.courses.location.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.location.data)) || [];

                              if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {

                                  return ggCourseSearchSvc.search.fetchCourseSearchByGeoCode({ latitude: latitude, longitude: longitude }).then(function (data) {

                                      if (data && data.status == "200") {

                                          var courses = data.data.value;
                                          ggStorage.set(ggStorage.keys.courses.location.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.courses.location.data, courses);
                                      }
                                      return courses;

                                  }, function (error) { return error; });

                              } else {
                                  return $q.resolve(storeData);
                              }
                          }
                      }
                   }
                   , Invitations: {

                       fetch: function (isRefresh) {

                            var form = {
                                email: _member.Detail.email
                                , memberId: _member.Detail.id
                            };
                            var storeData = [];
                            return ggInvitations.search.fetchInvitations(form).then(function (data) {
                                if (data && data.status == "200") {
                                    
                                    for (var x = 0; x < data.data.value.length; x++) {
                                        var item = data.data.value[x];
                                        var expDate = new Date(item.expiresOn);
                                        var now = new Date();

                                        item.expiresIn = expDate - now;

                                        if (item.expiresIn > 0 && item.responseType == ggInvitations.responseTypes.noresponse) {
                                            storeData.push(item);
                                        }
                                    }
                                }
                                return storeData;
                            }, function (error) { return error; });
                       }
                   }
                   , Groups: {
                       fetch: function (isRefresh) {

                           // Get Current Storage
                           var isCurrent = ggStorage.get(ggStorage.keys.groups.my.isCurrent);
                           var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.my.data)) || [];

                           if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                               // Reset storage
                               ggStorage.set(ggStorage.keys.groups.my.isCurrent, false);
                               ggStorage.set(ggStorage.keys.groups.my.data, null);

                               return ggGroupSvc.search.fetchGroupSearchByMember({ memberId: _member.Detail.id }).then(function (data) {
                                   if (data && data.status == "200") {
                                       var groups = data.data.value
                                       ggStorage.set(ggStorage.keys.groups.my.isCurrent, true);
                                       ggStorage.set(ggStorage.keys.groups.my.data, groups);
                                   }
                                   return groups;
                               }, function (error) { return error; });
                           } else {
                               return $q.resolve(storeData);
                           }

                       }
                      , unfollow: function (id) {
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.my.data)) || [];
                          for (var l = 0; l < storeData.length; l++) {
                              var item = storeData[l];
                              if (item.group.id == id) {
                                  storeData.splice(l, 1);
                                  ggStorage.set(ggStorage.keys.groups.my.data, storeData);
                                  break;
                              }
                          }
                      }
                      , isFollowing: function (id) {
                          var r = false;
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.my.data)) || [];
                          for (var l = 0; l < storeData.length; l++) {
                              var item = storeData[l];
                              if (item.group.id == id) {
                                  r = true;
                                  break;
                              }
                          }
                          return r;
                      }
                      , organizer: {
                          fetch: function (isRefresh) {
                              // Get Current Storage
                              var isCurrent = ggStorage.get(ggStorage.keys.groups.organizer.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.organizer.data)) || [];

                              if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                  // Reset storage
                                  ggStorage.set(ggStorage.keys.groups.organizer.isCurrent, false);
                                  ggStorage.set(ggStorage.keys.groups.organizer.data, null);

                                  return ggGroupSvc.search.fetchGroupSearchByMember({ memberId: _member.Detail.id }).then(function (data) {
                                      if (data && data.status == "200") {
                                          var groups = data.data.value
                                          var res = []
                                          for (var g = 0; g < groups.length; g++) {
                                              if (groups[g].group.createdBy.id == _member.Detail.id) {
                                                  res.push(groups[g]);
                                              }
                                          }

                                          ggStorage.set(ggStorage.keys.groups.my.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.groups.my.data, groups);

                                          ggStorage.set(ggStorage.keys.groups.organizer.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.groups.organizer.data, res);
                                      }
                                      return res;
                                  }, function (error) { return error; });

                              } else {
                                  return $q.resolve(storeData);
                              }
                          }
                      }
                      , allmygroups: {
                          fetch: function (isRefresh) {
                              // Get Current Storage
                              var isCurrent = ggStorage.get(ggStorage.keys.groups.allmygroups.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.allmygroups.data)) || [];

                              if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                  // Reset storage
                                  ggStorage.set(ggStorage.keys.groups.allmygroups.isCurrent, false);
                                  ggStorage.set(ggStorage.keys.groups.allmygroups.data, null);

                                  return ggGroupSvc.search.fetchGroupSearchByMember({ memberId: _member.Detail.id }).then(function (data) {
                                      var res = [];
                                      if (data && data.status == "200") {
                                          res = data.data.value;
                                          ggStorage.set(ggStorage.keys.groups.allmygroups.isCurrent, true);
                                          ggStorage.set(ggStorage.keys.groups.allmygroups.data, res);
                                      }
                                      return res;
                                  },
                                  function (error) {
                                      return error;
                                  });
                              } else {
                                  return $q.resolve(storeData);
                              }
                          }

                      }
                       , nearme: {
                           fetch: function (isRefresh) {
                               // Get Current Storage
                               var isCurrent = ggStorage.get(ggStorage.keys.groups.nearme.isCurrent);
                               var storeData = JSON.parse(ggStorage.get(ggStorage.keys.groups.nearme.data)) || [];

                               if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                                   // Reset storage
                                   ggStorage.set(ggStorage.keys.groups.nearme.isCurrent, false);
                                   ggStorage.set(ggStorage.keys.groups.nearme.data, null);

                                   return ggGroupSvc.search.fetchGroupsNearMe({ memberId: _member.Detail.id }).then(function (data) {
                                       var res = [];
                                       if (data && data.status == "200") {
                                           res = data.data.value;
                                           ggStorage.set(ggStorage.keys.groups.nearme.isCurrent, true);
                                           ggStorage.set(ggStorage.keys.groups.nearme.data, res);
                                       }
                                       return res;
                                   },
                                   function (error) {
                                       return error;
                                   });
                               } else {
                                   return $q.resolve(storeData);
                               }
                           }

                       }
                   }
                   , Clubs: {
                       fetch: function (isRefresh) {
                           // Get Current Storage
                           var isCurrent = ggStorage.get(ggStorage.keys.clubs.my.isCurrent);
                           var storeData = JSON.parse(ggStorage.get(ggStorage.keys.clubs.my.data)) || [];

                           if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                               // Reset storage
                               ggStorage.set(ggStorage.keys.clubs.my.isCurrent, false);
                               ggStorage.set(ggStorage.keys.clubs.my.data, null);

                               return ggHandicap.search.fetchHandicapClubsByMember({ memberId: _member.Detail.id }).then(function (data) {
                                   if (data && data.status == "200") {

                                       var clubs = data.data.value;
                                       ggStorage.set(ggStorage.keys.clubs.my.isCurrent, true);
                                       ggStorage.set(ggStorage.keys.clubs.my.data, data.data.value);

                                       if (clubs.length > 0) {
                                           for (var c = 0; c < clubs.length; c++) {
                                               if (clubs[c].isPrimary) {
                                                   ggStorage.set(ggStorage.keys.clubs.primary, clubs[c]);
                                               }
                                           }
                                       }
                                   }
                                   return clubs;
                               }, function (error) { return error; });
                           } else {
                               return $q.resolve(storeData);
                           }
                       }
                      , isFollowing: function (id) {
                          var r = false;
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.clubs.my.data)) || [];
                          for (var l = 0; l < storeData.length; l++) {
                              var item = storeData[l];
                              if (item.id == id) {
                                  r = true;
                                  break;
                              }
                          }
                          return r;
                      }
                   }
                   , Scoring: {
                       recent: function (isRefresh) {
                           // Get Current Storage
                           var isCurrent = ggStorage.get(ggStorage.keys.scoring.recent.isCurrent);
                           var storeData = JSON.parse(ggStorage.get(ggStorage.keys.scoring.recent.data)) || [];

                           if ((isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0))) {
                               // Reset storage
                               ggStorage.set(ggStorage.keys.scoring.recent.isCurrent, false);
                               ggStorage.set(ggStorage.keys.scoring.recent.data, null);

                               return ggScoringSvc.search.fetchScoresByMember({ top: 30, memberId: app.Member.Detail.id }).then(function (data) {
                                   if (data && data.status == "200") {
                                       var scores = data.data.value;
                                       ggStorage.set(ggStorage.keys.scoring.recent.isCurrent, true);
                                       ggStorage.set(ggStorage.keys.scoring.recent.data, scores);

                                       return scores;
                                   }
                               }, function (error) { return error });
                           } else {
                               return $q.resolve(storeData);
                           }
                       }
                   }
                }
            }
        }

        var _Role = function () {
            this.RoleId = null;
            this.Name = "";
            this.Domain = "";
        }


        //##//--------------------------------------- 

        this.NewMember = function () {

            var NewMember = new _Member;

            // Set Defaults
            NewMember.Auth.isAuthenticated = false;
            NewMember.Detail.gender = "Male";

            // Check Storage
            NewMember.Auth.userName = ggStorage.get(ggStorage.keys.member.username);

            // Default Role
            var Role = new _Role;
            Role.RoleId = -1;
            Role.Name = "ANONYMOUS";
            Role.Domain = "";
            NewMember.Auth.roles.push(Role);

            return NewMember;
        };

    }
}(angular, app));

